// **** Auto-generated by Sparkhound.CodeGenerator. ****
import { Injectable, OnInit } from '@angular/core';
import { ExecuteCommandService } from '../services/execute-command.service';
import { CommandResponseTyped } from './framework/commandResponse';
import * as Web from './CommandServiceDtos.generated';
import * as Search from './framework/searchObjects';
import * as _ from 'lodash';


@Injectable()
export class ApiService {

    public constructor(
        public executeCommandService: ExecuteCommandService
    ) {
    
    }

    public async Search<T>(request: Search.SearchCommandRequest, useBusyIndicator?: boolean, showNotificationOnSuccess?: boolean): Promise<Search.SearchCommandResponse<T>> {
        let response: CommandResponseTyped<Search.SearchCommandResponse<T>> = await this.executeCommandService.executeCommand("Search", request, useBusyIndicator, showNotificationOnSuccess);
        let result = response.Payload;
        return result;
    }

    public async Admin(request: Web.AdminCommandRequest, useBusyIndicator?: boolean, showNotificationOnSuccess?: boolean): Promise<Web.AdminCommandResponse> {
        let response: CommandResponseTyped<Web.AdminCommandResponse> = await this.executeCommandService.executeCommand(Web.CommandNames.Admin, request, useBusyIndicator, showNotificationOnSuccess);
        let result = response.Payload;
        return result;
    }

    public async CreateTestDummyCommandQueue(request: Web.CreateTestDummyCommandQueueCommandRequest, useBusyIndicator?: boolean, showNotificationOnSuccess?: boolean): Promise<Web.CreateTestDummyCommandQueueCommandResponse> {
        let response: CommandResponseTyped<Web.CreateTestDummyCommandQueueCommandResponse> = await this.executeCommandService.executeCommand(Web.CommandNames.CreateTestDummyCommandQueue, request, useBusyIndicator, showNotificationOnSuccess);
        let result = response.Payload;
        return result;
    }

    public async CreateUser(request: Web.CreateUserCommandRequest, useBusyIndicator?: boolean, showNotificationOnSuccess?: boolean): Promise<Web.CreateUserCommandResponse> {
        let response: CommandResponseTyped<Web.CreateUserCommandResponse> = await this.executeCommandService.executeCommand(Web.CommandNames.CreateUser, request, useBusyIndicator, showNotificationOnSuccess);
        let result = response.Payload;
        return result;
    }

    public async DeleteCheckpoint(request: Web.DeleteCheckpointCommandRequest, useBusyIndicator?: boolean, showNotificationOnSuccess?: boolean): Promise<Web.DeleteCheckpointCommandResponse> {
        let response: CommandResponseTyped<Web.DeleteCheckpointCommandResponse> = await this.executeCommandService.executeCommand(Web.CommandNames.DeleteCheckpoint, request, useBusyIndicator, showNotificationOnSuccess);
        let result = response.Payload;
        return result;
    }

    public async DeleteExample(request: Web.DeleteExampleCommandRequest, useBusyIndicator?: boolean, showNotificationOnSuccess?: boolean): Promise<object> {
        let response: CommandResponseTyped<object> = await this.executeCommandService.executeCommand(Web.CommandNames.DeleteExample, request, useBusyIndicator, showNotificationOnSuccess);
        let result = response.Payload;
        return result;
    }

    public async DeleteRole(request: Web.DeleteRoleCommandRequest, useBusyIndicator?: boolean, showNotificationOnSuccess?: boolean): Promise<Web.DeleteRoleCommandResponse> {
        let response: CommandResponseTyped<Web.DeleteRoleCommandResponse> = await this.executeCommandService.executeCommand(Web.CommandNames.DeleteRole, request, useBusyIndicator, showNotificationOnSuccess);
        let result = response.Payload;
        return result;
    }

    public async ExecuteAllPendingQueues(request: Web.ExecuteAllPendingQueuesCommandRequest, useBusyIndicator?: boolean, showNotificationOnSuccess?: boolean): Promise<Web.ExecuteAllPendingQueuesCommandResponse> {
        let response: CommandResponseTyped<Web.ExecuteAllPendingQueuesCommandResponse> = await this.executeCommandService.executeCommand(Web.CommandNames.ExecuteAllPendingQueues, request, useBusyIndicator, showNotificationOnSuccess);
        let result = response.Payload;
        return result;
    }

    public async ExecuteNextQueueEntry(request: Web.ExecuteNextQueueEntryCommandRequest, useBusyIndicator?: boolean, showNotificationOnSuccess?: boolean): Promise<Web.ExecuteNextQueueEntryCommandResponse> {
        let response: CommandResponseTyped<Web.ExecuteNextQueueEntryCommandResponse> = await this.executeCommandService.executeCommand(Web.CommandNames.ExecuteNextQueueEntry, request, useBusyIndicator, showNotificationOnSuccess);
        let result = response.Payload;
        return result;
    }

    public async ExecutePendingQueueEntries(request: Web.ExecutePendingQueueEntriesCommandRequest, useBusyIndicator?: boolean, showNotificationOnSuccess?: boolean): Promise<Web.ExecutePendingQueueEntriesCommandResponse> {
        let response: CommandResponseTyped<Web.ExecutePendingQueueEntriesCommandResponse> = await this.executeCommandService.executeCommand(Web.CommandNames.ExecutePendingQueueEntries, request, useBusyIndicator, showNotificationOnSuccess);
        let result = response.Payload;
        return result;
    }

    public async GetApplicationSetting(request: Web.GetApplicationSettingCommandRequest, useBusyIndicator?: boolean, showNotificationOnSuccess?: boolean): Promise<Web.GetApplicationSettingCommandResponse> {
        let response: CommandResponseTyped<Web.GetApplicationSettingCommandResponse> = await this.executeCommandService.executeCommand(Web.CommandNames.GetApplicationSetting, request, useBusyIndicator, showNotificationOnSuccess);
        let result = response.Payload;
        return result;
    }

    public async GetCheckpoint(request: Web.GetCheckpointCommandRequest, useBusyIndicator?: boolean, showNotificationOnSuccess?: boolean): Promise<Web.GetCheckpointCommandResponse> {
        let response: CommandResponseTyped<Web.GetCheckpointCommandResponse> = await this.executeCommandService.executeCommand(Web.CommandNames.GetCheckpoint, request, useBusyIndicator, showNotificationOnSuccess);
        let result = response.Payload;
        return result;
    }

    public async GetClientAndAssetListByUser(request: Web.GetClientAndAssetListByUserCommandRequest, useBusyIndicator?: boolean, showNotificationOnSuccess?: boolean): Promise<Web.GetClientAndAssetListByUserCommandResponse> {
        let response: CommandResponseTyped<Web.GetClientAndAssetListByUserCommandResponse> = await this.executeCommandService.executeCommand(Web.CommandNames.GetClientAndAssetListByUser, request, useBusyIndicator, showNotificationOnSuccess);
        let result = response.Payload;
        return result;
    }

    public async GetCountry(request: Web.GetCountryCommandRequest, useBusyIndicator?: boolean, showNotificationOnSuccess?: boolean): Promise<Web.GetCountryCommandResponse> {
        let response: CommandResponseTyped<Web.GetCountryCommandResponse> = await this.executeCommandService.executeCommand(Web.CommandNames.GetCountry, request, useBusyIndicator, showNotificationOnSuccess);
        let result = response.Payload;
        return result;
    }

    public async GetDashboard(request: Web.GetDashboardCommandRequest, useBusyIndicator?: boolean, showNotificationOnSuccess?: boolean): Promise<Web.GetDashboardCommandResponse> {
        let response: CommandResponseTyped<Web.GetDashboardCommandResponse> = await this.executeCommandService.executeCommand(Web.CommandNames.GetDashboard, request, useBusyIndicator, showNotificationOnSuccess);
        let result = response.Payload;
        return result;
    }

    public async GetExample(request: Web.GetExampleCommandRequest, useBusyIndicator?: boolean, showNotificationOnSuccess?: boolean): Promise<Web.GetExampleCommandResponse> {
        let response: CommandResponseTyped<Web.GetExampleCommandResponse> = await this.executeCommandService.executeCommand(Web.CommandNames.GetExample, request, useBusyIndicator, showNotificationOnSuccess);
        let result = response.Payload;
        return result;
    }

    public async GetException(request: Web.GetExceptionCommandRequest, useBusyIndicator?: boolean, showNotificationOnSuccess?: boolean): Promise<Web.GetExceptionCommandResponse> {
        let response: CommandResponseTyped<Web.GetExceptionCommandResponse> = await this.executeCommandService.executeCommand(Web.CommandNames.GetException, request, useBusyIndicator, showNotificationOnSuccess);
        let result = response.Payload;
        return result;
    }

    public async GetExecutionBarChart(request: Web.GetExecutionBarChartCommandRequest, useBusyIndicator?: boolean, showNotificationOnSuccess?: boolean): Promise<Web.GetExecutionBarChartCommandResponse> {
        let response: CommandResponseTyped<Web.GetExecutionBarChartCommandResponse> = await this.executeCommandService.executeCommand(Web.CommandNames.GetExecutionBarChart, request, useBusyIndicator, showNotificationOnSuccess);
        let result = response.Payload;
        return result;
    }

    public async GetExecutionChart(request: Web.GetExecutionChartCommandRequest, useBusyIndicator?: boolean, showNotificationOnSuccess?: boolean): Promise<Web.GetExecutionChartCommandResponse> {
        let response: CommandResponseTyped<Web.GetExecutionChartCommandResponse> = await this.executeCommandService.executeCommand(Web.CommandNames.GetExecutionChart, request, useBusyIndicator, showNotificationOnSuccess);
        let result = response.Payload;
        return result;
    }

    public async GetExecutionCurrentStatusChart(request: Web.GetExecutionCurrentStatusChartCommandRequest, useBusyIndicator?: boolean, showNotificationOnSuccess?: boolean): Promise<Web.GetExecutionCurrentStatusChartCommandResponse> {
        let response: CommandResponseTyped<Web.GetExecutionCurrentStatusChartCommandResponse> = await this.executeCommandService.executeCommand(Web.CommandNames.GetExecutionCurrentStatusChart, request, useBusyIndicator, showNotificationOnSuccess);
        let result = response.Payload;
        return result;
    }

    public async GetExecutionStatus(request: Web.GetExecutionStatusCommandRequest, useBusyIndicator?: boolean, showNotificationOnSuccess?: boolean): Promise<Web.GetExecutionStatusCommandResponse> {
        let response: CommandResponseTyped<Web.GetExecutionStatusCommandResponse> = await this.executeCommandService.executeCommand(Web.CommandNames.GetExecutionStatus, request, useBusyIndicator, showNotificationOnSuccess);
        let result = response.Payload;
        return result;
    }

    public async GetMaterialsStatus(request: Web.GetMaterialsStatusCommandRequest, useBusyIndicator?: boolean, showNotificationOnSuccess?: boolean): Promise<Web.GetMaterialsStatusCommandResponse> {
        let response: CommandResponseTyped<Web.GetMaterialsStatusCommandResponse> = await this.executeCommandService.executeCommand(Web.CommandNames.GetMaterialsStatus, request, useBusyIndicator, showNotificationOnSuccess);
        let result = response.Payload;
        return result;
    }

    public async GetPrimaveraSummaryReport(request: Web.GetPrimaveraSummaryReportCommandRequest, useBusyIndicator?: boolean, showNotificationOnSuccess?: boolean): Promise<Web.GetPrimaveraSummaryReportCommandResponse> {
        let response: CommandResponseTyped<Web.GetPrimaveraSummaryReportCommandResponse> = await this.executeCommandService.executeCommand(Web.CommandNames.GetPrimaveraSummaryReport, request, useBusyIndicator, showNotificationOnSuccess);
        let result = response.Payload;
        return result;
    }

    public async GetProjectModuleDisplaySettings(request: Web.GetProjectModuleDisplaySettingsCommandRequest, useBusyIndicator?: boolean, showNotificationOnSuccess?: boolean): Promise<Web.GetProjectModuleDisplaySettingsCommandResponse> {
        let response: CommandResponseTyped<Web.GetProjectModuleDisplaySettingsCommandResponse> = await this.executeCommandService.executeCommand(Web.CommandNames.GetProjectModuleDisplaySettings, request, useBusyIndicator, showNotificationOnSuccess);
        let result = response.Payload;
        return result;
    }

    public async GetProjectsByUser(request: Web.GetProjectsByUserCommandRequest, useBusyIndicator?: boolean, showNotificationOnSuccess?: boolean): Promise<Web.GetProjectsByUserCommandResponse> {
        let response: CommandResponseTyped<Web.GetProjectsByUserCommandResponse> = await this.executeCommandService.executeCommand(Web.CommandNames.GetProjectsByUser, request, useBusyIndicator, showNotificationOnSuccess);
        let result = response.Payload;
        return result;
    }

    public async GetProjectSetup(request: Web.GetProjectSetupCommandRequest, useBusyIndicator?: boolean, showNotificationOnSuccess?: boolean): Promise<Web.GetProjectSetupCommandResponse> {
        let response: CommandResponseTyped<Web.GetProjectSetupCommandResponse> = await this.executeCommandService.executeCommand(Web.CommandNames.GetProjectSetup, request, useBusyIndicator, showNotificationOnSuccess);
        let result = response.Payload;
        return result;
    }

    public async GetQueueDetail(request: Web.GetQueueDetailCommandRequest, useBusyIndicator?: boolean, showNotificationOnSuccess?: boolean): Promise<Web.GetQueueDetailCommandResponse> {
        let response: CommandResponseTyped<Web.GetQueueDetailCommandResponse> = await this.executeCommandService.executeCommand(Web.CommandNames.GetQueueDetail, request, useBusyIndicator, showNotificationOnSuccess);
        let result = response.Payload;
        return result;
    }

    public async GetReadinessStatus(request: Web.GetReadinessStatusCommandRequest, useBusyIndicator?: boolean, showNotificationOnSuccess?: boolean): Promise<Web.GetReadinessStatusCommandResponse> {
        let response: CommandResponseTyped<Web.GetReadinessStatusCommandResponse> = await this.executeCommandService.executeCommand(Web.CommandNames.GetReadinessStatus, request, useBusyIndicator, showNotificationOnSuccess);
        let result = response.Payload;
        return result;
    }

    public async GetReadinessSummary(request: Web.GetReadinessSummaryCommandRequest, useBusyIndicator?: boolean, showNotificationOnSuccess?: boolean): Promise<Web.GetReadinessSummaryCommandResponse> {
        let response: CommandResponseTyped<Web.GetReadinessSummaryCommandResponse> = await this.executeCommandService.executeCommand(Web.CommandNames.GetReadinessSummary, request, useBusyIndicator, showNotificationOnSuccess);
        let result = response.Payload;
        return result;
    }

    public async GetReleaseNumber(request: Web.GetReleaseNumberCommandRequest, useBusyIndicator?: boolean, showNotificationOnSuccess?: boolean): Promise<Web.GetReleaseNumberCommandResponse> {
        let response: CommandResponseTyped<Web.GetReleaseNumberCommandResponse> = await this.executeCommandService.executeCommand(Web.CommandNames.GetReleaseNumber, request, useBusyIndicator, showNotificationOnSuccess);
        let result = response.Payload;
        return result;
    }

    public async GetRole(request: Web.GetRoleCommandRequest, useBusyIndicator?: boolean, showNotificationOnSuccess?: boolean): Promise<Web.GetRoleCommandResponse> {
        let response: CommandResponseTyped<Web.GetRoleCommandResponse> = await this.executeCommandService.executeCommand(Web.CommandNames.GetRole, request, useBusyIndicator, showNotificationOnSuccess);
        let result = response.Payload;
        return result;
    }

    public async GetTaskPriorityStatus(request: Web.GetTaskPriorityStatusCommandRequest, useBusyIndicator?: boolean, showNotificationOnSuccess?: boolean): Promise<Web.GetTaskPriorityStatusCommandResponse> {
        let response: CommandResponseTyped<Web.GetTaskPriorityStatusCommandResponse> = await this.executeCommandService.executeCommand(Web.CommandNames.GetTaskPriorityStatus, request, useBusyIndicator, showNotificationOnSuccess);
        let result = response.Payload;
        return result;
    }

    public async GetUser(request: Web.GetUserCommandRequest, useBusyIndicator?: boolean, showNotificationOnSuccess?: boolean): Promise<Web.GetUserCommandResponse> {
        let response: CommandResponseTyped<Web.GetUserCommandResponse> = await this.executeCommandService.executeCommand(Web.CommandNames.GetUser, request, useBusyIndicator, showNotificationOnSuccess);
        let result = response.Payload;
        return result;
    }

    public async GetUserWidgetSelections(request: Web.GetUserWidgetSelectionsCommandRequest, useBusyIndicator?: boolean, showNotificationOnSuccess?: boolean): Promise<Web.GetUserWidgetSelectionsCommandResponse> {
        let response: CommandResponseTyped<Web.GetUserWidgetSelectionsCommandResponse> = await this.executeCommandService.executeCommand(Web.CommandNames.GetUserWidgetSelections, request, useBusyIndicator, showNotificationOnSuccess);
        let result = response.Payload;
        return result;
    }

    public async ImportPrimaveraP6(request: Web.ImportPrimaveraP6CommandRequest, useBusyIndicator?: boolean, showNotificationOnSuccess?: boolean): Promise<Web.ImportPrimaveraP6CommandResponse> {
        let response: CommandResponseTyped<Web.ImportPrimaveraP6CommandResponse> = await this.executeCommandService.executeCommand(Web.CommandNames.ImportPrimaveraP6, request, useBusyIndicator, showNotificationOnSuccess);
        let result = response.Payload;
        return result;
    }

    public async ImportReadinessTool(request: Web.ImportReadinessToolCommandRequest, useBusyIndicator?: boolean, showNotificationOnSuccess?: boolean): Promise<Web.ImportReadinessToolCommandResponse> {
        let response: CommandResponseTyped<Web.ImportReadinessToolCommandResponse> = await this.executeCommandService.executeCommand(Web.CommandNames.ImportReadinessTool, request, useBusyIndicator, showNotificationOnSuccess);
        let result = response.Payload;
        return result;
    }

    public async ImportSiteSense(request: Web.ImportSiteSenseCommandRequest, useBusyIndicator?: boolean, showNotificationOnSuccess?: boolean): Promise<Web.ImportSiteSenseCommandResponse> {
        let response: CommandResponseTyped<Web.ImportSiteSenseCommandResponse> = await this.executeCommandService.executeCommand(Web.CommandNames.ImportSiteSense, request, useBusyIndicator, showNotificationOnSuccess);
        let result = response.Payload;
        return result;
    }

    public async IsUserAuthenticated(request: Web.IsUserAuthenticatedCommandRequest, useBusyIndicator?: boolean, showNotificationOnSuccess?: boolean): Promise<Web.IsUserAuthenticatedCommandResponse> {
        let response: CommandResponseTyped<Web.IsUserAuthenticatedCommandResponse> = await this.executeCommandService.executeCommand(Web.CommandNames.IsUserAuthenticated, request, useBusyIndicator, showNotificationOnSuccess);
        let result = response.Payload;
        return result;
    }

    public async Login(request: Web.LoginCommandRequest, useBusyIndicator?: boolean, showNotificationOnSuccess?: boolean): Promise<Web.LoginCommandResponse> {
        let response: CommandResponseTyped<Web.LoginCommandResponse> = await this.executeCommandService.executeCommand(Web.CommandNames.Login, request, useBusyIndicator, showNotificationOnSuccess);
        let result = response.Payload;
        return result;
    }

    public async Logout(request: Web.LogoutCommandRequest, useBusyIndicator?: boolean, showNotificationOnSuccess?: boolean): Promise<object> {
        let response: CommandResponseTyped<object> = await this.executeCommandService.executeCommand(Web.CommandNames.Logout, request, useBusyIndicator, showNotificationOnSuccess);
        let result = response.Payload;
        return result;
    }

    public async LogTypeScriptError(request: Web.LogTypeScriptErrorCommandRequest, useBusyIndicator?: boolean, showNotificationOnSuccess?: boolean): Promise<object> {
        let response: CommandResponseTyped<object> = await this.executeCommandService.executeCommand(Web.CommandNames.LogTypeScriptError, request, useBusyIndicator, showNotificationOnSuccess);
        let result = response.Payload;
        return result;
    }

    public async PersistProjectSetup(request: Web.PersistProjectSetupCommandRequest, useBusyIndicator?: boolean, showNotificationOnSuccess?: boolean): Promise<Web.PersistProjectSetupCommandResponse> {
        let response: CommandResponseTyped<Web.PersistProjectSetupCommandResponse> = await this.executeCommandService.executeCommand(Web.CommandNames.PersistProjectSetup, request, useBusyIndicator, showNotificationOnSuccess);
        let result = response.Payload;
        return result;
    }

    public async SaveApplicationSetting(request: Web.SaveApplicationSettingCommandRequest, useBusyIndicator?: boolean, showNotificationOnSuccess?: boolean): Promise<Web.SaveApplicationSettingCommandResponse> {
        let response: CommandResponseTyped<Web.SaveApplicationSettingCommandResponse> = await this.executeCommandService.executeCommand(Web.CommandNames.SaveApplicationSetting, request, useBusyIndicator, showNotificationOnSuccess);
        let result = response.Payload;
        return result;
    }

    public async SaveCheckpoint(request: Web.SaveCheckpointCommandRequest, useBusyIndicator?: boolean, showNotificationOnSuccess?: boolean): Promise<Web.SaveCheckpointCommandResponse> {
        let response: CommandResponseTyped<Web.SaveCheckpointCommandResponse> = await this.executeCommandService.executeCommand(Web.CommandNames.SaveCheckpoint, request, useBusyIndicator, showNotificationOnSuccess);
        let result = response.Payload;
        return result;
    }

    public async SaveCountry(request: Web.SaveCountryCommandRequest, useBusyIndicator?: boolean, showNotificationOnSuccess?: boolean): Promise<Web.SaveCountryCommandResponse> {
        let response: CommandResponseTyped<Web.SaveCountryCommandResponse> = await this.executeCommandService.executeCommand(Web.CommandNames.SaveCountry, request, useBusyIndicator, showNotificationOnSuccess);
        let result = response.Payload;
        return result;
    }

    public async SaveExample(request: Web.SaveExampleCommandRequest, useBusyIndicator?: boolean, showNotificationOnSuccess?: boolean): Promise<Web.SaveExampleCommandResponse> {
        let response: CommandResponseTyped<Web.SaveExampleCommandResponse> = await this.executeCommandService.executeCommand(Web.CommandNames.SaveExample, request, useBusyIndicator, showNotificationOnSuccess);
        let result = response.Payload;
        return result;
    }

    public async SaveFormlyExample(request: Web.SaveFormlyExampleCommandRequest, useBusyIndicator?: boolean, showNotificationOnSuccess?: boolean): Promise<Web.SaveFormlyExampleCommandResponse> {
        let response: CommandResponseTyped<Web.SaveFormlyExampleCommandResponse> = await this.executeCommandService.executeCommand(Web.CommandNames.SaveFormlyExample, request, useBusyIndicator, showNotificationOnSuccess);
        let result = response.Payload;
        return result;
    }

    public async SaveRole(request: Web.SaveRoleCommandRequest, useBusyIndicator?: boolean, showNotificationOnSuccess?: boolean): Promise<Web.SaveRoleCommandResponse> {
        let response: CommandResponseTyped<Web.SaveRoleCommandResponse> = await this.executeCommandService.executeCommand(Web.CommandNames.SaveRole, request, useBusyIndicator, showNotificationOnSuccess);
        let result = response.Payload;
        return result;
    }

    public async SaveUser(request: Web.SaveUserCommandRequest, useBusyIndicator?: boolean, showNotificationOnSuccess?: boolean): Promise<Web.SaveUserCommandResponse> {
        let response: CommandResponseTyped<Web.SaveUserCommandResponse> = await this.executeCommandService.executeCommand(Web.CommandNames.SaveUser, request, useBusyIndicator, showNotificationOnSuccess);
        let result = response.Payload;
        return result;
    }

    public async SaveUserWidgetOrder(request: Web.SaveUserWidgetOrderCommandRequest, useBusyIndicator?: boolean, showNotificationOnSuccess?: boolean): Promise<Web.SaveUserWidgetOrderCommandResponse> {
        let response: CommandResponseTyped<Web.SaveUserWidgetOrderCommandResponse> = await this.executeCommandService.executeCommand(Web.CommandNames.SaveUserWidgetOrder, request, useBusyIndicator, showNotificationOnSuccess);
        let result = response.Payload;
        return result;
    }

    public async SaveUserWidgetSelections(request: Web.SaveUserWidgetSelectionsCommandRequest, useBusyIndicator?: boolean, showNotificationOnSuccess?: boolean): Promise<Web.SaveUserWidgetSelectionsCommandResponse> {
        let response: CommandResponseTyped<Web.SaveUserWidgetSelectionsCommandResponse> = await this.executeCommandService.executeCommand(Web.CommandNames.SaveUserWidgetSelections, request, useBusyIndicator, showNotificationOnSuccess);
        let result = response.Payload;
        return result;
    }

    public async SearchObjects(request: Web.SearchObjectsCommandRequest, useBusyIndicator?: boolean, showNotificationOnSuccess?: boolean): Promise<Web.SearchObjectsCommandResponse> {
        let response: CommandResponseTyped<Web.SearchObjectsCommandResponse> = await this.executeCommandService.executeCommand(Web.CommandNames.SearchObjects, request, useBusyIndicator, showNotificationOnSuccess);
        let result = response.Payload;
        return result;
    }

    public async TestDummy(request: Web.TestDummyCommandRequest, useBusyIndicator?: boolean, showNotificationOnSuccess?: boolean): Promise<Web.TestDummyCommandResponse> {
        let response: CommandResponseTyped<Web.TestDummyCommandResponse> = await this.executeCommandService.executeCommand(Web.CommandNames.TestDummy, request, useBusyIndicator, showNotificationOnSuccess);
        let result = response.Payload;
        return result;
    }

    public async TriggerServerException(request: Web.TriggerServerExceptionCommandRequest, useBusyIndicator?: boolean, showNotificationOnSuccess?: boolean): Promise<Web.TriggerServerExceptionCommandResponse> {
        let response: CommandResponseTyped<Web.TriggerServerExceptionCommandResponse> = await this.executeCommandService.executeCommand(Web.CommandNames.TriggerServerException, request, useBusyIndicator, showNotificationOnSuccess);
        let result = response.Payload;
        return result;
    }

    public async UnusedSecurityCheckpointSearch(request: Web.UnusedSecurityCheckpointSearchCommandRequest, useBusyIndicator?: boolean, showNotificationOnSuccess?: boolean): Promise<Web.UnusedSecurityCheckpointSearchCommandResponse> {
        let response: CommandResponseTyped<Web.UnusedSecurityCheckpointSearchCommandResponse> = await this.executeCommandService.executeCommand(Web.CommandNames.UnusedSecurityCheckpointSearch, request, useBusyIndicator, showNotificationOnSuccess);
        let result = response.Payload;
        return result;
    }
}



// WEBPACK FOOTER //
// ./src/app/data/ApiService.generated.ts